import React, { useState } from "react";
import {
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  TableRow,
  TableCell,
  IconButton,
  Button,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { CONSTANTS } from "../../common/constant";

import { throttle } from "lodash";


const { CANCEL_BUTTON, SAVE_BUTTON, EDIT_CATEGORY_TITLE, THROTTLE_DURATION } =
  CONSTANTS;

const CategoryListing = ({
  index,
  editedCategory,
  englishName,
  hindiName,
  inputChange,
  editClick,
  saveClick,
  deleteClick,
  disablePrimary = null,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const openEditModal = () => {
    editClick(index);
    setModalOpen(true);
    setErrors({});
  };

  const closeEditModal = () => {
    setModalOpen(false);
  };

  const throttledSave = throttle(async () => {
    try {
      await saveClick();
      closeEditModal();
    } catch (error) {
      console.error("Failed to update: ", error);
    }
  }, THROTTLE_DURATION);

  return (
    <TableRow>
      <TableCell>
        <Typography>{englishName}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{hindiName}</Typography>
      </TableCell>
      <TableCell>
        <>
          <IconButton aria-label="edit" color="primary" onClick={openEditModal}>
            <Edit />
          </IconButton>
          <IconButton aria-label="delete" color="error" onClick={deleteClick}>
            <Delete />
          </IconButton>
        </>
        <Dialog open={isModalOpen} onClose={closeEditModal}>
          <DialogTitle>{EDIT_CATEGORY_TITLE}</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              label="English Name"
              name="en"
              value={editedCategory?.name?.en || ""}
              onChange={inputChange}
              error={!!errors?.name?.en}
              helperText={errors?.name?.en}
            />
            <TextField
              fullWidth
              margin="dense"
              label="Hindi Name"
              name="hi"
              value={editedCategory?.name?.hi || ""}
              onChange={inputChange}
              error={!!errors?.name?.hi}
              helperText={errors?.name?.hi}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="isBlog"
                  onChange={inputChange}
                  checked={editedCategory?.isBlog || false}
                />
              }
              label="Applicable for Blogs"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="isBook"
                  onChange={inputChange}
                  checked={editedCategory?.isBook || false}
                />
              }
              label="Applicable for Books"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeEditModal}>{CANCEL_BUTTON}</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={throttledSave}
              disabled={disablePrimary}
            >
              {SAVE_BUTTON}
            </Button>
          </DialogActions>
        </Dialog>
      </TableCell>
    </TableRow>
  );
};

export default CategoryListing;
